import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import ErrorMessage from '../components/ErrorMessage';
import { fetchArqueoBaqueira } from '../actions/arqueosbaqueira';
import moment from 'moment';
import LoadingProgress from '../components/LoadingProgress';
import '../styles/ArqueosBaqueiraDetailsView.css';

class ArqueosBaqueiraDetailsView extends React.Component {

  componentDidMount() {
    const { id } = this.props.match.params;
    this.props.fetchArqueoBaqueira(id);
  }

  render() {
    const { arqueobaqueira, error, loading } = this.props;

    if (error) {
      return <ErrorMessage message={error.message} />;
    }

    if (!arqueobaqueira || loading) {
      return <LoadingProgress />
    }

    const infoRow = (label, value, extraClass = '') => (
      <div className="abqd-info-row">
        <span className="abqd-info-label">{label}</span>
        <span className={`abqd-info-value${extraClass ? ` ${extraClass}` : ''}`}>{value}</span>
      </div>
    )

    return (
      <div className="abqd-view">
        {/* Header */}
        <div className="abqd-header">
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-cash-register"></i>
                ARQUEO <span className="abqd-accent">{arqueobaqueira.locker_name}</span>
                <span className="abqd-datebadge">
                  <i className="far fa-calendar-alt"></i>
                  {moment(arqueobaqueira.date).format('DD/MM/YYYY')}
                </span>
              </h1>
            </div>
            <div className="header-actions">
              <Link to="/arqueosBaqueira" className="abqd-btn primary">
                <i className="fas fa-arrow-left"></i>
                Volver
              </Link>
            </div>
          </div>
        </div>

        {/* Info + payment totals */}
        <div className="abqd-top-grid">
          <div className="abqd-card">
            <div className="abqd-card-header">
              <i className="fas fa-info-circle"></i>
              Información General
            </div>
            <div className="abqd-card-body">
              {infoRow('Proyecto', arqueobaqueira.project)}
              {infoRow('Nombre de Taquilla', arqueobaqueira.locker_name)}
              {infoRow('Fecha de Inicio', moment(arqueobaqueira.start_date).format('DD/MM/YYYY HH:mm'))}
              {infoRow('Fecha de Fin', moment(arqueobaqueira.end_date).format('DD/MM/YYYY HH:mm'))}
              {infoRow('Fecha de Arqueo', moment(arqueobaqueira.date).format('DD/MM/YYYY HH:mm'))}
            </div>
          </div>

          <div className="abqd-card">
            <div className="abqd-card-header">
              <i className="fas fa-coins"></i>
              Totales de Pago
            </div>
            <div className="abqd-card-body">
              <div className="abqd-pay-grid">
                {arqueobaqueira.payments_totals.map((payment, index) => (
                  <div key={index} className="abqd-pay-card">
                    <span className="abqd-pay-title">
                      <i className="fas fa-coins"></i>
                      {payment.payment_form_id}
                    </span>
                    {infoRow('Cuenta', payment.cash_account)}
                    {infoRow('Importe Declarado', `${(payment.imp_dec / 100).toFixed(2)} €`)}
                    {infoRow('Importe Facturado', `${(payment.imp_fac / 100).toFixed(2)} €`)}
                    {infoRow('Diferencia', `${(payment.diff / 100).toFixed(2)} €`, payment.diff === 0 ? 'abqd-diff-ok' : 'abqd-diff-bad')}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Tickets */}
        <div className="abqd-card">
          <div className="abqd-card-header">
            <i className="fas fa-ticket-alt"></i>
            Tickets
            <span className="abqd-count">{arqueobaqueira.tickets.length}</span>
          </div>
          <div className="abqd-card-body">
            <div className="abqd-ticket-grid">
              {arqueobaqueira.tickets.map((ticket, index) => (
                <div key={index} className="abqd-ticket">
                  <div className="abqd-ticket-header">
                    <span className="abqd-ticket-title">
                      <i className="fas fa-file-invoice"></i>
                      Ticket {index + 1}
                    </span>
                    <span className="abqd-ticket-serial">{ticket.serial_number}</span>
                  </div>
                  <div className="abqd-ticket-body">
                    {infoRow('Compañía', ticket.company)}
                    {infoRow('Proyecto', ticket.project)}
                    {infoRow('Delegación', ticket.delega)}
                    {infoRow('Nombre de la Tienda', ticket.store_name)}
                    {infoRow('Tipo de Documento', ticket.tipdoc)}
                    {infoRow('Agregador', ticket.channel)}
                    {infoRow('NIF', ticket.nif_channel)}
                    {infoRow('Nombre del Cliente', ticket.name)}
                    {infoRow('Correo Electrónico', ticket.email)}
                    {infoRow('Número de Reserva', ticket.booking_number)}
                    {infoRow('País', ticket.country_name)}
                    {infoRow('Importe Total', `${(ticket.total_amount / 100).toFixed(2)} €`)}
                    {infoRow('Idioma', ticket.language)}

                    {ticket.details && ticket.details.length > 0 && (
                      <>
                        <h6 className="abqd-subheading">
                          <i className="fas fa-list"></i>
                          Detalles de Ticket
                        </h6>
                        {ticket.details.map((detail, detailIndex) => (
                          <div key={detailIndex} className="abqd-line-row">
                            <span>
                              {moment(detail.StartDate).format('DD/MM/YYYY')} - {moment(detail.EndDate).format('DD/MM/YYYY')}
                            </span>
                            <span className="abqd-amount">{(detail.Price).toFixed(2)} €</span>
                          </div>
                        ))}
                      </>
                    )}

                    {ticket.lines && ticket.lines.length > 0 && (
                      <>
                        <h6 className="abqd-subheading">
                          <i className="fas fa-align-justify"></i>
                          Líneas de Ticket
                        </h6>
                        {ticket.lines.map((line, lineIndex) => (
                          <div key={lineIndex} className="abqd-line-row">
                            <span>Taquilla: {line.locker_number}</span>
                            <span>Desc: {line.art_desc}</span>
                            <span>Code: {line.art_code}</span>
                            <span className="abqd-amount">{(line.amount / 100).toFixed(2)} €</span>
                          </div>
                        ))}
                      </>
                    )}

                    {ticket.ticket_payments && ticket.ticket_payments.length > 0 && (
                      <>
                        <h6 className="abqd-subheading">
                          <i className="fas fa-credit-card"></i>
                          Pagos de Ticket
                        </h6>
                        {ticket.ticket_payments.map((payment, paymentIndex) => (
                          <div key={paymentIndex} className="abqd-line-row">
                            <span>Forma de Pago: {payment.payment_form_id}</span>
                            <span>Cuenta: {payment.cash_account}</span>
                            <span className="abqd-amount">{(payment.payment_amount / 100).toFixed(2)} €</span>
                          </div>
                        ))}
                      </>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  arqueobaqueira: state.arqueosbaqueira.arqueobaqueira,
  loading: state.arqueosbaqueira.loading,
  error: state.arqueosbaqueira.error,
});

const mapDispatchToProps = (dispatch) => ({
  fetchArqueoBaqueira: (id) => dispatch(fetchArqueoBaqueira(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ArqueosBaqueiraDetailsView);
